// extracted by mini-css-extract-plugin
export default {"item":"ItemSliding_item__1zJGb","itemEditIcon":"ItemSliding_itemEditIcon__1uDVX","label":"ItemSliding_label__kW2nf","badge":"ItemSliding_badge__DUPYU"};